import { contacts } from "../data/profile";
import type { ContactIcon } from "../types";
import { useReveal } from "../hooks/useReveal";
import { useI18n } from "../i18n/LanguageContext";
import { Icon, type IconName } from "./Icon";
import { SectionHead } from "./SectionHead";
import styles from "./Contacts.module.css";

const ICON_MAP: Record<ContactIcon, IconName> = {
  email: "email",
  github: "github",
  website: "website",
  location: "location",
};

function isExternal(href: string) {
  return href.startsWith("http");
}

/** Show the domain the site is actually served from. */
function siteDomain(): string {
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "lorddarthart.github.io"
  ) {
    return "lorddarthart.github.io";
  }
  return "lorddarthart.ru";
}

export function Contacts() {
  const { t, ui } = useI18n();
  const reveal = useReveal();
  const domain = siteDomain();

  return (
    <section id="contact" className="section solid">
      <div className="container">
        <SectionHead
          eyebrow={ui.contacts.eyebrow}
          title={ui.contacts.title}
          sub={ui.contacts.sub}
        />

        <div className={styles.grid} ref={reveal}>
          {contacts.map((contact) => {
            const isWebsite = contact.icon === "website";
            const value = isWebsite ? domain : t(contact.value);
            const href = isWebsite ? `https://${domain}` : contact.href;
            return (
              <a
                key={contact.icon}
                href={href}
                className={styles.card}
                {...(isExternal(href)
                  ? { target: "_blank", rel: "noreferrer" }
                  : {})}
              >
                <span className={styles.icon}>
                  <Icon name={ICON_MAP[contact.icon]} size={22} />
                </span>
                <span className={styles.text}>
                  <span className={styles.label}>{t(contact.label)}</span>
                  <span className={styles.value}>{value}</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
